import React, { useState } from 'react'
import { Dialog, DialogTrigger } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/Button'
import { Modal, ModalHeader } from '@/components/Modal'
import FCDBIngredientsImporterPanel from './FCDBIngredientsImporterPanel'

export default function FCDBIngredientImporter() {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <DialogTrigger>
      <Button variant="primary" onPress={() => setIsOpen(true)}>
        {t('ingredient.importIngredient')}
      </Button>
      <Modal isOpen={isOpen} style={{ height: '90vh', maxHeight: '90vh' }}>
        <Dialog>
          {({ close }) => (
            <>
              <ModalHeader onClose={close}>{t('ingredient.importIngredient')}</ModalHeader>

              <FCDBIngredientsImporterPanel close={close} />
            </>
          )}
        </Dialog>
      </Modal>
    </DialogTrigger>
  )
}
